<template>
  <div id="application-title" style="margin-bottom: 20px;">
    <v-toolbar>
      <v-toolbar-title class="printable">
        Candidature (#{{$route.params.id}})
        <small>- le {{$store.getters['moduleApplications/getFormatedApplicationDate']}}</small>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-rating
        color="warning"
        background-color="warning"
        v-model="markerValue"
        v-if="!$store.getters['moduleUser/userIsResponsible']"
        :clearable="true"
        :hover="true"
      ></v-rating>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on }">
          <v-btn fab small v-on="on" @click="deleteApplication">
            <v-icon>delete</v-icon>
          </v-btn>
        </template>
        <span>Supprimer</span>
      </v-tooltip>
      <v-divider class="mx-3" inset vertical></v-divider>
      <v-toolbar-items>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn fab small v-on="on" @click="print">
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Imprimer</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn fab small v-on="on" @click="contact">
              <v-icon>email</v-icon>
            </v-btn>
          </template>
          <span>Contacter</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn fab small v-on="on" @click="exportData">
              <v-icon>get_app</v-icon>
            </v-btn>
          </template>
          <span>Exporter (Dossier complet)</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  name: 'application-title',
  data () {
    return {
      markerValue: null
    }
  },
  created () {
    this.markerValue = this.$store.state.moduleApplications.currentApplication.marker.marker_value
  },
  watch: {
    markerValue () { this.rate() }
  },
  methods: {
    print () {
      let print_divs = document.getElementsByClassName("printable")
      let print_area = window.open()
      print_area.document.write('<html><head><title>Candidature#' + this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id + '</title></head><body>');
      for (let div of print_divs) {
        print_area.document.write(div.innerHTML)
        print_area.document.write('<br>');
      }
      print_area.document.write('</body></html>');
      print_area.document.close()
      print_area.focus()
      print_area.print()
      print_area.close()
    },
    contact () { window.location.href = 'mailto:' + this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_mail },
    deleteApplication () {
      if (confirm('Voulez-vous vraiment supprimer cette candidature ? \n Cette action est irréversible.')) {
        this.$store.dispatch('moduleApplications/deleteApplication', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
        this.$router.push('/applications')
      }
    },
    exportData () { this.$store.dispatch('moduleApplications/exportData', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id, name: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_name + this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_fsname }) },
    rate () {
      // Already a value => update
      if (this.$store.state.moduleApplications.currentApplication.marker.marker_value) {
        if (this.markerValue == 0) {
          // New value is 0 => delete
          this.$store.dispatch('moduleApplications/deleteMarker', { id: this.$store.state.moduleApplications.currentApplication.marker.marker_id })
        } else {
          // New value => update
          this.$store.dispatch('moduleApplications/updateMarker', { id: this.$store.state.moduleApplications.currentApplication.marker.marker_id, applicant: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id, value: this.markerValue })
        }
      } else {
        // No existing value => create
        this.$store.dispatch('moduleApplications/createMarker', { applicant: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id, value: this.markerValue })
      }
      this.$store.dispatch('moduleApplications/getCurrentApplicationMarker', { id: this.$store.state.moduleApplications.currentApplication.application_data.personal_data.applicant_id })
    }
  }
}
</script>
